import React from 'react';
import ReactDOM from 'react-dom';
import { X, Sparkles } from 'lucide-react';
import { colors, typography, spacing, radius } from '../../styles/theme';

const FreeWelcomeModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const modalContent = (
    <>
      {/* Backdrop */}
      <div 
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          backdropFilter: 'blur(4px)',
          zIndex: 9998,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: spacing[4]
        }}
      >
        {/* Modal */}
        <div 
          onClick={(e) => e.stopPropagation()}
          style={{
            background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
            border: `2px solid ${colors.primary}`,
            borderRadius: radius.xl,
            padding: spacing[8],
            maxWidth: '420px',
            width: '100%',
            position: 'relative',
            boxShadow: '0 25px 50px rgba(0, 0, 0, 0.5)',
            fontFamily: typography.fontSans,
            textAlign: 'center'
          }}
        >
          {/* Close button */}
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: spacing[4],
              right: spacing[4],
              background: 'transparent',
              border: 'none',
              color: colors.textTertiary,
              cursor: 'pointer',
              padding: spacing[2],
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: radius.sm,
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(100, 116, 139, 0.2)';
              e.currentTarget.style.color = colors.textPrimary;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.color = colors.textTertiary;
            }}
          >
            <X size={20} />
          </button>

          {/* Icon */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: spacing[4]
          }}>
            <div style={{
              background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`,
              borderRadius: radius.full,
              padding: spacing[4],
              display: 'inline-flex'
            }}>
              <Sparkles size={32} color="white" />
            </div>
          </div>

          {/* Title */}
          <h2 style={{
            fontSize: typography['2xl'],
            fontWeight: typography.extrabold,
            color: colors.textPrimary,
            margin: `0 0 ${spacing[3]} 0`,
            lineHeight: typography.tight
          }}>
            🎉 Welcome to Free!
          </h2>

          {/* Description */}
          <p style={{
            fontSize: typography.base,
            color: colors.textSecondary,
            lineHeight: typography.relaxed,
            margin: `0 0 ${spacing[3]} 0`
          }}>
            You have <strong style={{ color: colors.primary }}>8 rounds per day</strong> to
            train your brain and track your progress.
          </p>

          <p style={{
            fontSize: typography.sm,
            color: colors.textTertiary,
            lineHeight: typography.relaxed,
            margin: `0 0 ${spacing[6]} 0`
          }}>
            Each round takes 1-2 minutes and helps improve your working memory!
          </p>

          {/* CTA Button */}
          <button
            onClick={onClose}
            style={{
              width: '100%',
              background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`,
              border: 'none',
              borderRadius: radius.lg,
              padding: `${spacing[4]} ${spacing[6]}`,
              fontSize: typography.lg,
              fontWeight: typography.bold,
              color: 'white',
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxShadow: '0 4px 12px rgba(96, 165, 250, 0.3)',
              fontFamily: typography.fontSans
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 16px rgba(96, 165, 250, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(96, 165, 250, 0.3)';
            }}
          >
            Start Training!
          </button>
        </div>
      </div>
    </>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default FreeWelcomeModal;

